import React from 'react';
import translate from '../locales/locales';
import Img from '../components/image';
import '../assets/styles/App.scss';

import logoCBCRC from "../assets/svg/cbc-radio-canada-white-blanc.svg";

function Footer() {
    return (
        <>
        <div className="footer">
        <div className="container white">
       <p>{translate.seo.creds}</p>
       <Img lazySrc="https://site-cbc.radio-canada.ca/site/edi/gem-load-grise.gif" className="footerImage" src={logoCBCRC} alt="" />
       </div>
       </div>
       </>
    );
}

export default Footer;